import { TemplateEditForm } from "./form";
import { Button, Space } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export default function TemplateEditPage() {
  const navigate = useNavigate();

  return (
    <div className="page-container" style={{ paddingBottom: 32 }}>
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
          style={{
            width: "fit-content",
            borderRadius: 12,
            paddingInline: 20,
            fontWeight: 500,
          }}
        >
          Шаблоны ответов
        </Button>
        <TemplateEditForm />
      </Space>
    </div>
  );
}
